export default __webpack_public_path__ + "static/media/img3.11eae563.png";